export const POOL_MAX_ITEMS = 8;

export const MEDIA_POOL_SOURCE_MODES = {
  MEDIA: 'MEDIA',
  MESSAGE: 'MESSAGE',
};

export const MEDIA_POOL_SEARCH_MODES = {
  MEDIA: MEDIA_POOL_SOURCE_MODES.MEDIA,
  MESSAGE: MEDIA_POOL_SOURCE_MODES.MESSAGE,
  SEARCH: 'SEARCH',
};
